module.exports = "../images/loading.gif?v=5d25806";